import get from 'lodash/get';

export const makeTestimonialsSection = (s, testimonials) => {
  return {
    name: s.key,
    pdf: s.url,
    data: {
      sectionTitle: get(s, 'sectionData.title'),
    },
    dataSource: testimonials,
  };
};